<div class="row">
  <div class="lqd-column col-md-6 col-md-offset-3 text-center">
    <h2 appTranslate="confirmation.title"></h2>
    <p appTranslate="confirmation.thanks"></p>
    <p appTranslate="confirmation.remarks"></p>

    <div class="lqd-column col-md-6 col-md-offset-3 text-center">
      <app-login hidden></app-login>
    </div>
  </div>
</div>
